import { configureStore } from '@reduxjs/toolkit';
import courierReducer from './state/courierSlice';
import authReducer from './state/authSlice';
import billingReducer from './state/billingSlice';
import cacheReducer from './state/cacheSlice';
import authorizedUsersReducer from './state/authorizedUsersSlice';
import assistantChatReducer from './state/assistantChatSlice';
import notificationReducer from './state/notificationSlice';
import notificationTemplatesReducer from './state/notificationTemplatesSlice';

export const store = configureStore({
  reducer: {
    courier: courierReducer,
    auth: authReducer,
    billing: billingReducer,
    cache: cacheReducer,
    authorizedUser: authorizedUsersReducer,
    assistantChat: assistantChatReducer,
    notification: notificationReducer,
    notificationTemplates: notificationTemplatesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore paths that may contain Date objects from the API
        ignoredPaths: [
          'courier.courier.legalDocument.lastUpdatedTerms',
          'courier.courier.legalDocument.lastUpdatedPrivacy',
          'courier.originalCourier.legalDocument.lastUpdatedTerms',
          'courier.originalCourier.legalDocument.lastUpdatedPrivacy',
          'courier.impersonatedCourier.legalDocument.lastUpdatedTerms',
          'courier.impersonatedCourier.legalDocument.lastUpdatedPrivacy',
        ],
        // Ignore these action types for serializable check
        ignoredActionPaths: [
          'payload.legalDocument.lastUpdatedTerms',
          'payload.legalDocument.lastUpdatedPrivacy',
        ],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
